import React, { useEffect, useState } from 'react'

import clsx from 'clsx'

import Form from 'components/Form'
import Review from 'components/Review'
import Typography from 'components/Typography'
import { kFormatter } from 'helpers/formatters'
import { revealSEOUrl } from 'helpers/SEOHelper'

import CategoryLeadersLabel from './components/CategoryLeadersLabel'
import ReviewStarBreakdownBar from './components/ReviewStarBreakdownBar'

import classes from './FormControlLabel.module.scss'

const noop = () => {}

/** @type {import("./types").default} */
const FormControlLabel = ({
  checkboxColor = 'primary',
  disabled = false,
  href = '',
  type = 'text',
  label,
  ratingValues = {},
  ratingDistributionValues = {},
  value,
  isChecked = false,
  fullWidth,
  onClick = noop,
}) => {
  const [checked, setChecked] = useState(isChecked)
  const handleCheckboxClick = (event, link) => {
    if (link) event.preventDefault()
    const currentChecked = !checked
    onClick(event, { link, value: value || label, isChecked: currentChecked, label })
    setChecked(currentChecked)
  }

  const { rating, reviewsNum } = ratingValues
  const { reviews, starRating, percentage, label: ratingDistributionLabel } = ratingDistributionValues

  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])

  const labels = {
    image: (
      <>
        <CategoryLeadersLabel />
        {label}
      </>
    ),
    rating: <Review.Rating rating={disabled ? 0 : rating || 0} xs reviewsNum={disabled ? 0 : reviewsNum || 0} />,
    ratingDistribution: (
      <ReviewStarBreakdownBar
        reviews={disabled ? 0 : kFormatter(reviews)}
        starRating={starRating}
        percentage={disabled ? 0 : percentage}
      />
    ),
    text: (
      <Typography
        variant="tight-sm"
        component="div"
        className={clsx(classes.labelTypography, { [classes.fullWidth]: fullWidth })}
      >
        {label}
      </Typography>
    ),
  }

  const checkbox = (
    <Form.Checkbox
      className={{ colorPrimary: classes.colorPrimary, checked: classes.checked }}
      checked={checked}
      value={label || ratingDistributionLabel}
      onChange={event => handleCheckboxClick(event, revealSEOUrl(href))}
      color={checkboxColor}
      disabled={disabled}
    />
  )

  return (
    <Form.ControlLabel
      labelClassName={classes.controlLabel}
      className="FormControlLabel"
      disabled={disabled}
      type={type}
      control={checkbox}
      fullWidth={fullWidth}
      labelComponent={
        href ? (
          <a
            className={clsx({ [classes.fullWidth]: fullWidth }, classes.link)}
            href={href}
            onClick={event => handleCheckboxClick(event, revealSEOUrl(href))}
          >
            {labels[type]}
          </a>
        ) : (
          labels[type]
        )
      }
    />
  )
}

export default React.memo(FormControlLabel)
